import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_ONBOARD_URL, API_ROUTES_ONBOARD } from "../../config/apiConfig";
import { useNavigate } from "react-router-dom";
import "./Users.css";

interface Traveler {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  dateOfBirth: string;
  gender: string;
  phone: string;
  profilePic: string;
  cognito_user_id: string;
  created_at: string;
  isActive: boolean;
}

const Users: React.FC = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState<string>("");
  const [travellersList, setTravellersList] = useState<Traveler[]>([]);
  const [filteredTravellers, setFilteredTravellers] = useState<Traveler[]>([]);

  useEffect(() => {
    fetchTravelers();
  }, []);

  useEffect(() => {
    filterTravelers();
  }, [searchText, travellersList]);

  const fetchTravelers = async () => {
    try {
      const response = await axios.get(
        `${API_ONBOARD_URL}${API_ROUTES_ONBOARD.profile}`
      );
      setTravellersList(response.data as Traveler[]);
      console.log("response", response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const filterTravelers = () => {
    if (searchText) {
      const filteredData = travellersList.filter((traveller) =>
        `${traveller.firstName} ${traveller.lastName}`
          .toLowerCase()
          .includes(searchText.toLowerCase())
      );

      setFilteredTravellers(filteredData);
    } else {
      setFilteredTravellers(travellersList);
    }
  };

  const deleteUser = async (cognitoUserId: string, name: string) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete ${name}?`
    );
    if (!confirmDelete) return;

    try {
      // Delete user from user API
      const userApiUrl = `${API_ONBOARD_URL}${API_ROUTES_ONBOARD.userByCognitoId}${cognitoUserId}/`;
      // console.log('userApiUrl', userApiUrl);
      const userApiConfig = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      await axios.delete(userApiUrl, userApiConfig);

      // Delete user from profile API
      const profileApiUrl = `${API_ONBOARD_URL}${API_ROUTES_ONBOARD.profileByCognitoId}${cognitoUserId}/`;
      // console.log('profileApiUrl', profileApiUrl);
      const profileApiConfig = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      await axios.delete(profileApiUrl, profileApiConfig);

      alert("User deleted successfully");

      setTravellersList((prevList) =>
        prevList.filter(
          (traveller) => traveller.cognito_user_id !== cognitoUserId
        )
      );
    } catch (error) {
      console.error("Error deleting user", error);
    }
  };

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  return (
    <div className="users-container">
      <div className="search-container">
        <input
          type="text"
          className="search-input"
          placeholder="Search by name"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>

      <div className="table-wrapper">
        <table className="user-table">
          <thead>
            <tr>
              <th>Profile</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Gender</th>
              <th>DOB</th>
              <th>User Since</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredTravellers.length > 0 ? (
              filteredTravellers.map((traveler) => (
                <tr key={traveler.id}>
                  <td>
                    <img
                      src={traveler.profilePic}
                      alt="Profile"
                      className="profile-pic"
                      onClick={() =>
                        navigate(`/traveler/${traveler.cognito_user_id}`)
                      }
                    />
                  </td>
                  <td className="name-cell">
                    {traveler.firstName} {traveler.lastName}
                  </td>
                  <td className="email-cell">{traveler.email}</td>
                  <td className="phone-cell">{traveler.phone}</td>
                  <td>{traveler.gender}</td>
                  <td>{formatDate(traveler.dateOfBirth)}</td>
                  <td>{formatDate(traveler.created_at)}</td>
                  <td>
                    <button
                      className="btn-delete"
                      onClick={() =>
                        deleteUser(
                          traveler.cognito_user_id,
                          `${traveler.firstName} ${traveler.lastName}`
                        )
                      }
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8} className="empty-list-text">
                  No Travelers Found!
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Users;

//------------------------------------------

// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import axios from "axios";
// import {  API_ONBOARD_URL, API_ROUTES_ONBOARD } from "../../config/apiConfig";;
// import { useNavigate } from "react-router-dom";
// import "./Users.css";

// interface Traveler {
//   id: number;
//   firstName: string;
//   lastName: string;
//   friendsCount: number;
//   tripsCount: number;
//   profilePic: string;
//   cognito_user_id: string;
// }

// const Users: React.FC = () => {
//   const navigate = useNavigate();
//   const [searchText, setSearchText] = useState<string>("");
//   const [travellersList, setTravellersList] = useState<Traveler[]>([]);
//   const [filteredTravellers, setFilteredTravellers] = useState<Traveler[]>([]);

//   useEffect(() => {
//     fetchTravelers();
//   }, []);

//   useEffect(() => {
//     filterTravelers();
//   }, [searchText, travellersList]);

//   const fetchTravelers = async () => {
//     try {
//       const response = await axios.get(`${API_ONBOARD_URL}${API_ROUTES_ONBOARD.profile}`);
//       setTravellersList(response.data as Traveler[]);
//       console.log(response.data);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const filterTravelers = () => {
//     if (searchText) {
//       const filteredData = travellersList.filter((traveller) =>
//         `${traveller.firstName} ${traveller.lastName}`.toLowerCase().includes(searchText.toLowerCase())
//       );
//       setFilteredTravellers(filteredData);
//     } else {
//       setFilteredTravellers(travellersList);
//     }
//   };

//   const RenderList: React.FC<Traveler> = ({ firstName, lastName, friendsCount, tripsCount, profilePic, cognito_user_id }) => (
//     <div className="item-container">
//       <img src={profilePic} alt="Traveler" className="image" onClick={() => navigate(`/traveler/${cognito_user_id}`)} />
//       <div className="info-container">
//         <h3 className="name" onClick={() => navigate(`/traveler/${cognito_user_id}`)}>
//           {firstName} {lastName}
//         </h3>
//         {/* <div className="stats-container">
//           <span className="stat">
//             {friendsCount} "Friends"
//           </span>
//           <span className="stat">
//             {tripsCount} "Trips"
//           </span>
//         </div> */}

//       </div>
//     </div>
//   );

//   return (
//     <div className="container">
//       <div className="search-container">
//         <input
//           type="text"
//           className="search-input"
//           placeholder="Search"
//           value={searchText}
//           onChange={(e) => setSearchText(e.target.value)}
//         />
//       </div>
//       <div className="list-container">
//         {filteredTravellers.length > 0 ? (
//           filteredTravellers.map((traveler) => <RenderList key={traveler.id} {...traveler} />)
//         ) : (
//           <p className="empty-list-text">No Travellers Found !</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Users;
